import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChange } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { InitialsPipe } from "../shared/pipes/intials.pipe";
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AddAdminInsurerComponent } from '../add-admin-insurer/add-admin-insurer.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { AddAdminProviderComponent } from '../add-admin-provider/add-admin-provider.component';
import { AddAdminDistributorComponent } from '../add-admin-distributor/add-admin-distributor.component';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonAdminComponentComponent } from '../super-admin/orgs-registration/common-admin-registration/common-admin-component.component';
import { OrgsRegistrationComponent } from '../super-admin/orgs-registration/orgs-registration.component';

@Component({
  selector: 'app-admin-card',
  standalone: true,
  imports: [MatInputModule, FormsModule, CommonModule, InitialsPipe, MatTooltipModule],
  templateUrl: './admin-card.component.html',
  styleUrl: './admin-card.component.scss'
})
export class AdminCardComponent {
  @Input() insurer: any;
  @Input() role: any;
  constructor(private router: Router, private dialog: MatDialog, private notificationService: NotificationService,
    private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

  }


  copiedEmail: string | null = null;
  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }

  onCardClick() {
    this.router.navigateByUrl(`dashboard/adminprofile/${this.insurer.userId}`)
    if (this.role === 'ADMIN_DISTRIBUTOR') {
      this.router.navigateByUrl(`dashboard/adminprofile/${this.insurer.users[0].userId}`)

    }
  }

  // ngOnChanges(changes:SimpleChange):void{
  //   console.log(changes['insurer'])

  // }

  onEditAgent(): void {
    if (this.insurer.active) {
      this.notificationService.showNotification("You cannot edit an inactive agent", 'error');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '750px';
    dialogConfig.height = '550px';
    dialogConfig.data = this.insurer;

    switch (this.role) {
      case 'ADMIN_INSURER':
        this.dialog.open(CommonAdminComponentComponent, dialogConfig);
        break;
      case 'ADMIN_PROVIDER':
        this.dialog.open(CommonAdminComponentComponent, dialogConfig);
        break;
      case 'ADMIN_DISTRIBUTOR':
        this.dialog.open(CommonAdminComponentComponent, dialogConfig);
        break;
        case 'INSURER_ORG':
        this.dialog.open(OrgsRegistrationComponent, dialogConfig);
        break;
      case 'PROVIDER_ORG':
        this.dialog.open(OrgsRegistrationComponent, dialogConfig);
        break;
      case 'DISTRIBUTOR_ORG':
        this.dialog.open(OrgsRegistrationComponent, dialogConfig);
        break;
      default:
        this.notificationService.showNotification("Invalid role for editing agent", 'error');
        break;
    }
  }


  onStatusUpdate(status: boolean): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'WARNING';
    const rawMessage = `Are you sure you want to update the status to <span style="color: ${status ? 'green' : 'red'};">${status ? 'Active' : 'Deactive'}</span>?`;
    dialogRef.componentInstance.message = this.sanitizer.bypassSecurityTrustHtml(rawMessage);

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        if(this.role==='INSURER_ORG' || this.role==='DISTRIBUTOR_ORG' || this.role==='PROVIDER_ORG'){

          this.restService.updateOrganisationStatus(this.insurer.orgId, status).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.role === 'ADMIN_INSURER')
              this.memberService.emitRefreshAdminInsurer();
            else if (this.role === 'ADMIN_PROVIDER') {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        })

        }
        else{
        this.restService.updateAdminStatus(this.insurer.userId, status).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.role === 'ADMIN_INSURER')
              this.memberService.emitRefreshAdminInsurer();
            else if (this.role === 'ADMIN_PROVIDER') {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });}
      }
    })
  }

  @Input() cityName: string = 'Visakhapatnam';
  @Input() price: number = 390;
  @Input() rtcAvailable: boolean = true;
}
